var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149.77734pt",
    height: "298.93359pt",
    viewBox: "0 0 149.77734 298.93359",
    id: "svg572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.3125,2.828125 C 2.226562,3.015625 2.039062,3.109375 1.75,3.109375 1.664062,3.109375 1.582031,3.09375 1.5,3.0625 L 1.078125,2.953125 C 0.597656,2.828125 0.28125,2.578125 0.125,2.203125 0.0390625,2.015625 0,1.796875 0,1.546875 V 0.71875 C 0,0.582031 0.0703125,0.515625 0.21875,0.515625 c 0.132812,0 0.203125,0.066406 0.203125,0.203125 v 0.953125 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 1.5,2.625 c 0.09375,0.019531 0.175781,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.75 c 0,-0.148438 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070312 0.21875,0.21875 v 0.5 c 0,0.257812 0.101563,0.476562 0.3125,0.65625 C 2.992188,3 3.101562,3.0625 3.21875,3.09375 c 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.300781,0 0.453125,-0.171875 0.453125,-0.515625 V 1.765625 c 0,-0.148437 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070313 0.21875,0.21875 v 0.9375 c 0,0.332031 -0.152344,0.582031 -0.453125,0.75 -0.136719,0.0625 -0.277344,0.09375 -0.421875,0.09375 -0.0625,0 -0.132813,-0.00781 -0.203125,-0.015625 C 2.75,3.40625 2.445312,3.171875 2.3125,2.828125 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,1.671875 c 0,0.4375 0.21875,0.710937 0.65625,0.828125 L 1.5,2.625 c 0.082031,0.019531 0.164062,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.453125 l -1.0625,-0.28125 C 1.003906,1.148438 0.945312,1.140625 0.90625,1.140625 0.769531,1.140625 0.65625,1.1875 0.5625,1.28125 0.46875,1.382812 0.421875,1.515625 0.421875,1.671875 Z M 0,1.546875 c 0,-0.304687 0.15625,-0.542969 0.46875,-0.71875 0.132812,-0.085937 0.273438,-0.125 0.421875,-0.125 0.0625,0 0.117187,0.007813 0.171875,0.03125 l 1.296875,0.34375 c 0.476563,0.125 0.878906,0.335937 1.203125,0.640625 0.351562,0.332031 0.59375,0.769531 0.71875,1.3125 0.00781,0.019531 0.015625,0.039062 0.015625,0.0625 0,0.132812 -0.074219,0.203125 -0.21875,0.203125 C 3.953125,3.296875 3.882812,3.25 3.875,3.15625 3.84375,2.914062 3.753906,2.675781 3.609375,2.4375 3.335938,2 2.992188,1.722656 2.578125,1.609375 V 2.25 C 2.578125,2.488281 2.5,2.6875 2.34375,2.84375 2.1875,3.007812 1.984375,3.09375 1.734375,3.09375 1.648438,3.09375 1.570312,3.082031 1.5,3.0625 L 1.078125,2.953125 C 0.578125,2.816406 0.253906,2.570312 0.109375,2.21875 0.0351562,2.039062 0,1.816406 0,1.546875 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.109375,3.03125 0.09375,1.796875 C 0.03125,1.753906 0,1.691406 0,1.609375 0,1.546875 0.0195312,1.492188 0.0625,1.453125 0.113281,1.410156 0.164062,1.390625 0.21875,1.390625 l 3.859375,0.15625 c 0.144531,0 0.21875,0.066406 0.21875,0.203125 0,0.15625 -0.078125,0.234375 -0.234375,0.234375 L 1.015625,1.84375 2.90625,3.015625 C 2.96875,3.046875 3,3.101562 3,3.1875 3,3.320312 2.9375,3.394531 2.8125,3.40625 L 0.984375,3.546875 4.171875,5.125 c 0.082031,0.039062 0.125,0.101562 0.125,0.1875 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.59375 C 0.0351562,3.550781 0,3.488281 0,3.40625 0,3.257812 0.0664062,3.1875 0.203125,3.1875 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,2.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.921875,1.046875 c 0.101563,0.03125 0.15625,0.101563 0.15625,0.21875 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.421875,1 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.140625,2.640625 V 1.46875 L 0.421875,1 v 1.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.859375,1.03125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.53125 C 4.296875,3.675781 4.222656,3.75 4.078125,3.75 3.929688,3.75 3.859375,3.675781 3.859375,3.53125 V 1.921875 l -1.28125,-0.34375 v 1.0625 c 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.148437,0 -0.21875,-0.070312 -0.21875,-0.203125 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.078125,1.53125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.15625 c 0,0.21875 -0.09375,0.410156 -0.28125,0.578125 C 3.828125,3.910156 3.617188,4 3.390625,4 3.328125,4 3.269531,3.992188 3.21875,3.984375 L 1.078125,3.40625 C 0.359375,3.207031 0,2.738281 0,2 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 Z M 3.859375,1.921875 0.421875,1 v 1.109375 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 3.21875,3.53125 C 3.269531,3.539062 3.320312,3.546875 3.375,3.546875 3.519531,3.546875 3.632812,3.5 3.71875,3.40625 3.8125,3.3125 3.859375,3.1875 3.859375,3.03125 Z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.71875,4.28125 H 0 V 0.25 c 0.175781,0 0.347656,0.03125 0.515625,0.09375 0.28125,0.101562 0.550781,0.265625 0.8125,0.484375 C 1.597656,1.054688 1.90625,1.382812 2.25,1.8125 c 0.539062,0.664062 0.96875,1.113281 1.28125,1.34375 0.320312,0.238281 0.625,0.359375 0.90625,0.359375 0.300781,0 0.550781,-0.109375 0.75,-0.328125 C 5.394531,2.976562 5.5,2.703125 5.5,2.359375 5.5,2.003906 5.390625,1.71875 5.171875,1.5 4.960938,1.28125 4.664062,1.171875 4.28125,1.171875 L 4.359375,0.40625 C 4.929688,0.457031 5.367188,0.65625 5.671875,1 5.972656,1.34375 6.125,1.800781 6.125,2.375 6.125,2.957031 5.957031,3.421875 5.625,3.765625 5.300781,4.109375 4.898438,4.28125 4.421875,4.28125 4.179688,4.28125 3.941406,4.226562 3.703125,4.125 3.472656,4.03125 3.226562,3.863281 2.96875,3.625 2.707031,3.394531 2.347656,3.015625 1.890625,2.484375 1.515625,2.023438 1.257812,1.734375 1.125,1.609375 0.988281,1.484375 0.851562,1.378906 0.71875,1.296875 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3,0.359375 c 0.726562,0 1.3125,0.070313 1.75,0.21875 0.4375,0.144531 0.773438,0.363281 1.015625,0.65625 C 6.003906,1.523438 6.125,1.894531 6.125,2.34375 6.125,2.664062 6.054688,2.953125 5.921875,3.203125 5.785156,3.453125 5.59375,3.65625 5.34375,3.8125 5.101562,3.96875 4.800781,4.09375 4.4375,4.1875 4.082031,4.28125 3.601562,4.328125 3,4.328125 2.289062,4.328125 1.710938,4.253906 1.265625,4.109375 0.828125,3.960938 0.488281,3.742188 0.25,3.453125 0.0078125,3.160156 -0.109375,2.789062 -0.109375,2.34375 -0.109375,1.75 0.101562,1.285156 0.53125,0.953125 1.03125,0.554688 1.851562,0.359375 3,0.359375 Z M 3,1.125 C 2,1.125 1.332031,1.238281 1,1.46875 0.675781,1.707031 0.515625,2 0.515625,2.34375 c 0,0.34375 0.164063,0.628906 0.5,0.859375 C 1.347656,3.441406 2.007812,3.5625 3,3.5625 4.007812,3.5625 4.675781,3.441406 5,3.203125 5.332031,2.972656 5.5,2.679688 5.5,2.328125 5.5,1.984375 5.351562,1.710938 5.0625,1.515625 4.6875,1.253906 4,1.125 3,1.125 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0.625 h 6.09375 v 0.8125 h -5.375 v 3 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g574",
    transform: "translate(-135.89062,-172.25391)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,5.33333e-6 h -34.880208 m -5.119792,0 h -5.28125 m -5.119792,0 h -5.119791 m -5.28125,0 H -86.71814 m -5.119792,0 h -5.119791 m -5.281247,0 h -5.1198 m -5.11979,0 h -25.92187 m -5.28125,0 h -5.11979 m -5.27604,0 h -5.125",
    transform: "matrix(0.75,0,0,0.75,285.48001,471)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 216.31771,628 H 181.4375 v -30.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,0.00149067 V -5.118301 m 0,-5.28125 v -5.119792 m 0,-5.119791 v -25.921875 m 0,-5.28125 v -5.119792 m 0,-5.276042 v -5.119791 m 0,-5.119792 v -25.921875 m 0,-5.281249 v -5.11979 m 0,-5.11979 v -5.28125 m 0,-5.1198 v -25.91666 m 0,-5.11979 v -5.28125 m 0,-5.1198 v -5.28125 m 0,-5.11979 v -25.92187 m 0,-5.11979 v -5.27605 m 0,-5.11979 v -5.125 m 0,-5.27604 v -25.92187 m 0,-5.1198 v -5.11979 m 0,-5.28125 v -5.11979 m 0,-5.28125 v -25.75521 m 0,-5.28125 v -5.11979 m 0,-5.28125 v -5.11979",
    transform: "matrix(0.75,0,0,0.75,136.08,444.11998)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 181.4375,260.64063 v -30.71875 h 34.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,0.00188233 h 5.125 m 5.276042,0 h 5.119791 m 5.28125,0 h 25.921875 m 5.119792,0 h 5.119792 m 5.28125,0 h 5.119791 m 5.119792,0 H 98.39854 m 5.28125,0 h 5.11979 m 5.11979,0 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,166.08,172.43999)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 345.76042,229.92188 h 34.8802 v 30.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,4.12e-4 v 5.119792 m 0,5.28125 v 5.119791 m 0,5.28125 v 25.755209 m 0,5.28125 v 5.119791 m 0,5.28125 v 5.119792 m 0,5.119792 v 25.921875 m 0,5.276036 v 5.125 m 0,5.1198 v 5.27604 m 0,5.11979 v 25.92187 m 0,5.1198 v 5.28125 m 0,5.11979 v 5.28125 m 0,5.11979 v 25.91667 m 0,5.11979 v 5.28125 m 0,5.11979 v 5.11979 m 0,5.28125 v 25.92188 m 0,5.11979 v 5.11979 m 0,5.27604 v 5.11979 m 0,5.28125 v 25.92188 m 0,5.11979 v 5.11979 m 0,5.28125 v 5.11979",
    transform: "matrix(0.75,0,0,0.75,285.48001,199.32)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 380.64062,597.28125 V 628",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.48047,172.44141 -0.24219,11.03906 v -11.03906 z m 0,0",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.48047,172.44141 v 11.03906 h -0.24219 z m 0,0",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,183.23828 -1.67969,0.24219 v -0.24219 z m 0,0",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,183.23828 v 0.24219 h -1.67969 z m 0,0",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,181.80078 -0.11718,1.67969 v -1.67969 z m 0,0",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,181.80078 v 1.67969 h -0.11718 z m 0,0",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,174.23828 -1.32031,0.24219 v -0.24219 z m 0,0",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,174.23828 v 0.24219 h -1.32031 z m 0,0",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,172.44141 -8.75781,0.11718 v -0.11718 z m 0,0",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,172.44141 v 0.11718 h -8.75781 z m 0,0",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.48047,172.44141 -0.24219,2.03906 v -2.03906 z m 0,0",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.48047,172.44141 v 2.03906 h -0.24219 z m 0,0",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,0.00188233 H 12.320618 m -12,0.15624967 H 11.997701 M 12.320618,0.00188233 V 14.720632 m -0.322917,-14.5625 v 14.239584 m 0.322917,0.322916 h -2.71875 m 2.395833,-0.322916 H 9.758118 m -0.15625,0.322916 v -2.239583 m 0.15625,1.916667 V 12.481049 M -0.00229867,0.00188233 V 2.720632 M 0.320618,0.158132 V 2.397716 M -0.00229867,2.720632 H 2.081035",
    transform: "matrix(0.75,0,0,0.75,276.24,172.43999)",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 368.64062,232.31771 h 1.76042 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001862,0.001053 h -0.15625 m -3.041667,-9.760417 v 0.796875 m 0,0.322917 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.322917 v 0.958333 m 0,0.317708 v 0.963542 m 0,0.161458 v 0.958334",
    transform: "matrix(0.75,0,0,0.75,283.55999,181.79999)",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 374.88021,239.83855 v 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00250733 H 0.80249 m 0.317708,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.317709,0 h 0.963541",
    transform: "matrix(0.75,0,0,0.75,277.32001,181.91999)",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 376.95833,242.5625 h 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,172.44141 0.24219,11.03906 v -11.03906 z m 0,0",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,172.44141 v 11.03906 h 0.24219 z m 0,0",
    id: "path197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 136.32031,183.23828 138,183.48047 v -0.24219 z m 0,0",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,183.23828 v 0.24219 H 138 Z m 0,0",
    id: "path199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 138,181.80078 0.12109,1.67969 v -1.67969 z m 0,0",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 138,181.80078 v 1.67969 h 0.12109 z m 0,0",
    id: "path201"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.76172,174.23828 1.3164,0.24219 v -0.24219 z m 0,0",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.76172,174.23828 v 0.24219 h 1.3164 z m 0,0",
    id: "path203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,172.44141 8.75781,0.11718 v -0.11718 z m 0,0",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,172.44141 v 0.11718 h 8.75781 z m 0,0",
    id: "path205"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,172.44141 0.24219,2.03906 v -2.03906 z m 0,0",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,172.44141 v 2.03906 h 0.24219 z m 0,0",
    id: "path207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.21667e-4,0.00188233 H -12.322495 m 12,0.15624967 H -11.999578 M -12.322495,0.00188233 V 14.720632 m 0.322917,-14.5625 v 14.239584 m -0.322917,0.322916 h 2.723958 m -2.401041,-0.322916 h 2.239583 m 0.161458,0.322916 v -2.239583 m -0.161458,1.916667 V 12.481049 M 4.21667e-4,0.00188233 V 2.720632 M -0.322495,0.158132 V 2.397716 M 4.21667e-4,2.720632 H -2.077703",
    transform: "matrix(0.75,0,0,0.75,145.32,172.43999)",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 193.4375,232.31771 h -1.75521 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,0.001053 h 0.161458 m 3.036459,-9.760417 v 0.796875 m 0,0.322917 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.322917 v 0.958333 m 0,0.317708 v 0.963542 m 0,0.161458 v 0.958334",
    transform: "matrix(0.75,0,0,0.75,138,181.79999)",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 187.19792,239.83855 v 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,0.00250733 H -0.799174 m -0.322916,0 h -0.958334 m -0.317708,0 h -0.963542 m -0.15625,0 h -0.963541 m -0.317709,0 h -0.958333 m -0.322917,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,144.24,181.91999)",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 185.11979,242.5625 h -0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.48047,471 -0.24219,-10.92188 V 471 Z m 0,0",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.48047,471 v -10.92188 h -0.24219 z m 0,0",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,460.19922 -1.67969,-0.1211 v 0.1211 z m 0,0",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,460.19922 v -0.1211 h -1.67969 z m 0,0",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,461.64062 -0.11718,-1.5625 v 1.5625 z m 0,0",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,461.64062 v -1.5625 h -0.11718 z m 0,0",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,469.19922 -1.32031,-0.23828 v 0.23828 z m 0,0",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,469.19922 v -0.23828 h -1.32031 z m 0,0",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,471 -8.75781,-0.12109 V 471 Z m 0,0",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,471 v -0.12109 h -8.75781 z m 0,0",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.48047,471 -0.24219,-2.03906 V 471 Z m 0,0",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.48047,471 v -2.03906 h -0.24219 z m 0,0",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,5.33333e-6 H 12.320618 M 0.320618,-0.161453 H 11.997701 M 12.320618,5.33333e-6 V -14.562495 m -0.322917,14.401042 v -14.239583 m 0.322917,-0.161459 h -2.71875 m 2.395833,0.161459 H 9.758118 m -0.15625,-0.161459 v 2.083334 m 0.15625,-1.921875 v 1.921875 M -0.00229867,5.33333e-6 V -2.718745 M 0.320618,-0.161453 V -2.401036 M -0.00229867,-2.718745 H 2.081035",
    transform: "matrix(0.75,0,0,0.75,276.24,471)",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 368.64062,625.59896 h 1.76042 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001862,8.18667e-4 h -0.15625 M -3.199779,9.761235 V 8.959152 m 0,-0.317708 V 7.677902 m 0,-0.15625 V 6.55811 m 0,-0.317708 V 5.282069 m 0,-0.322917 V 4.000819 m 0,-0.161459 V 2.881027",
    transform: "matrix(0.75,0,0,0.75,283.55999,461.64001)",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 374.88021,618.07813 V 617.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-6.04667e-4 H 0.80249 m 0.317708,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.317709,0 h 0.963541",
    transform: "matrix(0.75,0,0,0.75,277.32001,461.51999)",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 376.95833,615.35938 h 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,471 0.24219,-10.92188 V 471 Z m 0,0",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,471 v -10.92188 h 0.24219 z m 0,0",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 136.32031,460.19922 138,460.07812 v 0.1211 z m 0,0",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,460.19922 v -0.1211 H 138 Z m 0,0",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 138,461.64062 0.12109,-1.5625 v 1.5625 z m 0,0",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 138,461.64062 v -1.5625 h 0.12109 z m 0,0",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.76172,469.19922 1.3164,-0.23828 v 0.23828 z m 0,0",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.76172,469.19922 v -0.23828 h 1.3164 z m 0,0",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,471 8.75781,-0.12109 V 471 Z m 0,0",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.32031,471 v -0.12109 h 8.75781 z m 0,0",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,471 0.24219,-2.03906 V 471 Z m 0,0",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,471 v -2.03906 h 0.24219 z m 0,0",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.21667e-4,5.33333e-6 H -12.322495 m 12,-0.16145833333 H -11.999578 M -12.322495,5.33333e-6 V -14.562495 m 0.322917,14.401042 v -14.239583 m -0.322917,-0.161459 h 2.723958 m -2.401041,0.161459 h 2.239583 m 0.161458,-0.161459 v 2.083334 m -0.161458,-1.921875 v 1.921875 M 4.21667e-4,5.33333e-6 V -2.718745 M -0.322495,-0.161453 V -2.401036 M 4.21667e-4,-2.718745 H -2.077703",
    transform: "matrix(0.75,0,0,0.75,145.32,471)",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 193.4375,625.59896 h -1.75521 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,8.18667e-4 H 0.161458 M 3.197917,9.761235 V 8.959152 m 0,-0.317708 V 7.677902 m 0,-0.15625 V 6.55811 m 0,-0.317708 V 5.282069 m 0,-0.322917 V 4.000819 m 0,-0.161459 V 2.881027",
    transform: "matrix(0.75,0,0,0.75,138,461.64001)",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 187.19792,618.07813 V 617.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-6.04667e-4 H -0.799174 m -0.322916,0 h -0.958334 m -0.317708,0 h -0.963542 m -0.15625,0 h -0.963541 m -0.317709,0 h -0.958333 m -0.322917,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,144.24,461.51999)",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 185.11979,615.35938 h -0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 284.47917,280.31771 v 97.92188 h -6.23959 v -97.92188 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00229333 -0.481465,-0.63771 -1.27834,-1.122085 l -0.802084,-0.317708 -0.802083,-0.161459 -0.796875,0.161459 -0.802083,0.317708 -0.796875,0.484375 -0.479167,0.63541667",
    transform: "matrix(0.75,0,0,0.75,213.24,210.24)",
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00185667 0.481669,0.638768 1.278544,1.117935 2.080627,1.440852 2.877502,1.60231 3.679585,1.440852 4.481669,1.117935 5.278544,0.638768 5.75771,-0.00185667",
    transform: "matrix(0.75,0,0,0.75,208.92,283.55999)",
    id: "path387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 281.4375,280.31771 v 97.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path388"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g388"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 214.55679,
    y: 233.03831,
    id: "use388"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 11604.782,-10670.165 c 9.225,4.229 13.838,13.454 13.838,27.676 0,4.228 -0.769,8.264 -2.307,12.3 l -5.381,20.756 c -6.15,23.64 -18.45,39.207 -36.9,46.895 -9.226,4.228 -19.988,6.15 -32.288,6.15 H 11501 c -6.727,0 -9.994,-3.46 -9.994,-10.763 0,-6.534 3.267,-9.994 9.994,-9.994 h 46.894 c 9.225,0 17.681,-3.075 25.369,-9.225 8.072,-6.15 13.453,-13.838 16.144,-23.063 l 5.381,-20.756 c 0.961,-4.613 1.538,-8.649 1.538,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -18.45 c -7.304,0 -10.763,-3.46 -10.763,-10.763 0,-7.111 3.459,-10.762 10.763,-10.762 h 24.6 c 12.684,0 23.447,-4.997 32.288,-15.376 4.612,-4.996 7.687,-10.378 9.225,-16.143 0.384,-3.46 0.769,-6.535 0.769,-9.226 0,-14.798 -8.457,-22.294 -25.369,-22.294 h -40.745 c -7.303,0 -10.762,-3.459 -10.762,-10.762 0,-7.111 3.459,-10.763 10.762,-10.763 h 46.126 c 16.336,0 28.636,7.496 36.9,22.294 3.075,6.727 4.613,13.646 4.613,20.757 0,3.075 -0.385,6.534 -0.769,9.994 -6.15,23.062 -17.681,38.053 -34.594,44.587 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path389"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g389"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 214.55679,
    y: 236.15828,
    id: "use389"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 11701.453,-10577.145 c 21.525,0 34.979,-10.762 40.744,-32.288 l 6.15,-20.756 c 0.961,-4.036 1.538,-8.072 1.538,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -33.056 l -13.838,52.275 c -1.153,3.652 -1.538,6.535 -1.538,8.457 0,6.726 2.307,12.3 6.919,16.912 4.997,4.613 11.532,6.919 19.219,6.919 z m -6.15,20.757 c -14.991,0 -26.714,-7.688 -35.363,-23.063 -4.228,-6.535 -6.15,-13.453 -6.15,-20.757 0,-3.075 0.385,-5.765 1.538,-8.456 l 16.912,-63.807 c 6.15,-23.447 16.529,-43.242 31.519,-59.194 16.337,-17.297 37.862,-29.213 64.576,-35.363 0.961,-0.384 1.922,-0.769 3.075,-0.769 6.535,0 9.994,3.652 9.994,10.763 0,6.15 -2.306,9.609 -6.919,9.994 -11.916,1.537 -23.639,5.958 -35.363,13.069 -21.525,13.453 -35.17,30.366 -40.744,50.738 h 31.519 c 11.724,0 21.525,3.843 29.213,11.531 8.072,7.688 12.3,17.681 12.3,29.982 0,4.228 -0.576,8.071 -1.537,11.531 l -5.382,20.756 c -6.726,24.601 -18.834,40.552 -36.131,47.663 -8.841,3.652 -19.796,5.382 -33.057,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path390"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g390"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 214.55679,
    y: 239.15825,
    id: "use390"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 11915.937,-10660.171 -60.732,99.17 c -2.114,3.075 -5.189,4.613 -9.225,4.613 -3.075,0 -5.766,-0.961 -7.688,-3.075 -2.114,-2.499 -3.075,-4.997 -3.075,-7.688 l 7.688,-189.883 c 0,-7.111 3.267,-10.763 9.993,-10.763 7.688,0 11.532,3.844 11.532,11.532 l -6.919,149.907 57.657,-93.019 c 1.537,-3.075 4.228,-4.613 8.456,-4.613 6.535,0 10.186,3.075 10.763,9.225 l 6.919,89.945 77.644,-156.827 c 1.922,-4.036 4.997,-6.15 9.225,-6.15 7.111,0 10.763,3.652 10.763,10.763 0,1.537 -0.385,3.075 -0.769,4.612 l -94.557,190.652 c -2.114,3.652 -5.189,5.382 -9.225,5.382 -7.303,0 -10.763,-3.268 -10.763,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path391"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g391"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 214.67671,
    y: 248.03613,
    id: "use391"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12326.453,-10582.911 c 7.111,0 10.763,3.46 10.763,9.994 0,7.304 -3.652,10.763 -10.763,10.763 h -89.945 c -3.075,0 -5.765,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 l 51.507,-192.958 c 1.537,-4.997 4.997,-7.687 10.763,-7.687 6.534,0 9.993,3.651 9.993,10.762 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path392"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g392"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 214.67671,
    y: 251.0361,
    id: "use392"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12480.973,-10667.474 h -57.656 l -23.063,84.563 h 73.801 c 7.111,0 10.762,3.46 10.762,9.994 0,7.304 -3.651,10.763 -10.762,10.763 h -89.945 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.537,-1.922 -1.921,-4.613 -0.768,-7.688 l 50.738,-189.883 c 1.922,-7.111 6.918,-10.762 14.606,-10.762 h 83.795 c 7.111,0 10.762,3.651 10.762,10.762 0,7.303 -3.651,10.763 -10.762,10.763 h -79.182 l -16.913,63.038 h 52.275 c 6.535,0 9.994,3.652 9.994,10.763 0,7.303 -3.459,10.762 -9.994,10.762 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path393"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g393"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 214.67671,
    y: 254.03607,
    id: "use393"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12573.993,-10762.8 c 1.922,-7.111 6.919,-10.762 14.607,-10.762 h 65.344 c 10.763,0 20.18,4.612 28.444,13.837 8.648,9.225 13.069,19.604 13.069,30.751 0,3.075 -0.385,5.957 -0.769,8.456 l -28.444,105.32 c -9.802,35.363 -32.864,53.044 -69.188,53.044 h -65.345 c -3.075,0 -5.765,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 z m 19.219,10.763 -45.357,169.126 h 54.582 c 9.225,0 17.682,-3.075 25.369,-9.225 8.072,-6.15 13.453,-13.837 16.144,-23.062 l 28.444,-105.32 c 0.384,-2.499 0.769,-4.997 0.769,-7.688 0,-7.111 -2.306,-12.684 -6.919,-16.912 -4.612,-4.613 -10.763,-6.919 -18.45,-6.919 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 292.16146,330.71875 v 14.71875 h -6.23959 v -14.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 284.47917,484.16146 v 97.91667 h -6.23959 v -97.91667 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00229333 -0.481465,-0.63771 -1.27834,-1.122085 l -0.802084,-0.317708 -0.802083,-0.161459 -0.796875,0.161459 -0.802083,0.317708 -0.796875,0.484375 -0.479167,0.63541667",
    transform: "matrix(0.75,0,0,0.75,213.24,363.24)",
    id: "path397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00188667 0.481669,0.638738 1.278544,1.117905 2.080627,1.440822 2.877502,1.60228 3.679585,1.440822 4.481669,1.117905 5.278544,0.638738 5.75771,-0.00188667",
    transform: "matrix(0.75,0,0,0.75,208.92,436.56001)",
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 281.4375,484.16146 v 97.91667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path399"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g399"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 214.55679,
    y: 386.03476,
    id: "use399"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19132.265,-10670.165 c 9.225,4.229 13.838,13.454 13.838,27.676 0,4.228 -0.769,8.264 -2.307,12.3 l -5.381,20.756 c -6.15,23.64 -18.45,39.207 -36.9,46.895 -9.225,4.228 -19.988,6.15 -32.288,6.15 h -40.744 c -6.727,0 -9.994,-3.46 -9.994,-10.763 0,-6.534 3.267,-9.994 9.994,-9.994 h 46.894 c 9.225,0 17.681,-3.075 25.369,-9.225 8.072,-6.15 13.453,-13.838 16.144,-23.063 l 5.381,-20.756 c 0.961,-4.613 1.538,-8.649 1.538,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -18.45 c -7.304,0 -10.763,-3.46 -10.763,-10.763 0,-7.111 3.459,-10.762 10.763,-10.762 h 24.6 c 12.684,0 23.447,-4.997 32.288,-15.376 4.612,-4.996 7.687,-10.378 9.225,-16.143 0.384,-3.46 0.769,-6.535 0.769,-9.226 0,-14.798 -8.457,-22.294 -25.369,-22.294 h -40.745 c -7.303,0 -10.762,-3.459 -10.762,-10.762 0,-7.111 3.459,-10.763 10.762,-10.763 h 46.126 c 16.336,0 28.636,7.496 36.9,22.294 3.075,6.727 4.613,13.646 4.613,20.757 0,3.075 -0.385,6.534 -0.769,9.994 -6.15,23.062 -17.681,38.053 -34.594,44.587 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path400"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g400"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 214.55679,
    y: 389.15472,
    id: "use400"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19228.936,-10577.145 c 21.525,0 34.979,-10.762 40.744,-32.288 l 6.15,-20.756 c 0.961,-4.036 1.538,-8.072 1.538,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -33.056 l -13.838,52.275 c -1.153,3.652 -1.538,6.535 -1.538,8.457 0,6.726 2.307,12.3 6.919,16.912 4.997,4.613 11.532,6.919 19.219,6.919 z m -6.15,20.757 c -14.991,0 -26.714,-7.688 -35.363,-23.063 -4.228,-6.535 -6.15,-13.453 -6.15,-20.757 0,-3.075 0.385,-5.765 1.538,-8.456 l 16.912,-63.807 c 6.151,-23.447 16.529,-43.242 31.52,-59.194 16.336,-17.297 37.861,-29.213 64.575,-35.363 0.961,-0.384 1.922,-0.769 3.075,-0.769 6.535,0 9.994,3.652 9.994,10.763 0,6.15 -2.306,9.609 -6.919,9.994 -11.916,1.537 -23.639,5.958 -35.363,13.069 -21.525,13.453 -35.17,30.366 -40.744,50.738 h 31.519 c 11.724,0 21.525,3.843 29.213,11.531 8.072,7.688 12.3,17.681 12.3,29.982 0,4.228 -0.576,8.071 -1.537,11.531 l -5.382,20.756 c -6.726,24.601 -18.834,40.552 -36.131,47.663 -8.841,3.652 -19.796,5.382 -33.057,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path401"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g401"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 214.55679,
    y: 392.15469,
    id: "use401"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19443.42,-10660.171 -60.732,99.17 c -2.114,3.075 -5.189,4.613 -9.225,4.613 -3.075,0 -5.766,-0.961 -7.688,-3.075 -2.114,-2.499 -3.075,-4.997 -3.075,-7.688 l 7.688,-189.883 c 0,-7.111 3.267,-10.763 9.994,-10.763 7.687,0 11.531,3.844 11.531,11.532 l -6.919,149.907 57.657,-93.019 c 1.537,-3.075 4.228,-4.613 8.456,-4.613 6.535,0 10.186,3.075 10.763,9.225 l 6.919,89.945 77.644,-156.827 c 1.922,-4.036 4.997,-6.15 9.225,-6.15 7.111,0 10.763,3.652 10.763,10.763 0,1.537 -0.385,3.075 -0.769,4.612 l -94.557,190.652 c -2.114,3.652 -5.189,5.382 -9.225,5.382 -7.303,0 -10.763,-3.268 -10.763,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path402"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g402"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 214.67671,
    y: 401.03662,
    id: "use402"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19854.128,-10582.911 c 7.111,0 10.763,3.46 10.763,9.994 0,7.304 -3.652,10.763 -10.763,10.763 h -89.944 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.537,-1.922 -1.922,-4.613 -0.769,-7.688 l 51.507,-192.958 c 1.538,-4.997 4.997,-7.687 10.763,-7.687 6.534,0 9.994,3.651 9.994,10.762 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path403"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g403"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 214.67671,
    y: 404.03659,
    id: "use403"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 20008.649,-10667.474 h -57.657 l -23.063,84.563 h 73.801 c 7.111,0 10.763,3.46 10.763,9.994 0,7.304 -3.652,10.763 -10.763,10.763 h -89.945 c -3.075,0 -5.765,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 l 50.738,-189.883 c 1.922,-7.111 6.919,-10.762 14.606,-10.762 h 83.795 c 7.111,0 10.763,3.651 10.763,10.762 0,7.303 -3.652,10.763 -10.763,10.763 h -79.182 l -16.913,63.038 h 52.276 c 6.534,0 9.994,3.652 9.994,10.763 0,7.303 -3.46,10.762 -9.994,10.762 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path404"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g404"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 214.67671,
    y: 407.03656,
    id: "use404"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 20101.668,-10762.8 c 1.922,-7.111 6.919,-10.762 14.607,-10.762 h 65.344 c 10.763,0 20.18,4.612 28.444,13.837 8.649,9.225 13.069,19.604 13.069,30.751 0,3.075 -0.384,5.957 -0.769,8.456 l -28.444,105.32 c -9.801,35.363 -32.864,53.044 -69.188,53.044 h -65.344 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.537,-1.922 -1.922,-4.613 -0.769,-7.688 z m 19.219,10.763 -45.356,169.126 h 54.581 c 9.226,0 17.682,-3.075 25.369,-9.225 8.072,-6.15 13.454,-13.837 16.144,-23.062 l 28.444,-105.32 c 0.385,-2.499 0.769,-4.997 0.769,-7.688 0,-7.111 -2.306,-12.684 -6.919,-16.912 -4.612,-4.613 -10.762,-6.919 -18.45,-6.919 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 292.16146,534.71875 v 14.71875 h -6.23959 v -14.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path406"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/План Коридорний - х2.f332b95ff654fc3eaa23389a334637b2.svg";
export { ForwardRef as ReactComponent };